import React, { useEffect, useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import { Link } from "react-router-dom";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import SiteReviews from "../../../Components/site-reviews/SiteReviews";
import WhatsAppCMP from "../../../Components/WhatsApp";
import InfoSection from "../../../Components/InfoSection";
import ReferralProgram from "../../../Components/ReferralProgram";
import GatewaySolution from "../../../Components/GatewaySolution";

const AssignmentHelp = () => {
  const subCategoryId = "6586dfe7d2f7eeadeea4fafa";
  const categoryId = "65524e633c005ef3b51907c9";
  const categoryId2 = "6568bbce652c801ff8766635";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };


  
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="row mt-2 mb-2 px-4 m-0">
        <div className="col-lg-12">
          <div className="breadcrumb-inner text-start">
            <ul className="page-list">
              <li className="rbt-breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li>
                <div className="icon-right">
                  <MdOutlineKeyboardArrowRight />
                </div>
              </li>
              <li className="rbt-breadcrumb-item">Assignment Help</li>
              <li>
                <div className="icon-right">
                  <MdOutlineKeyboardArrowRight />
                </div>
              </li>
              <li className="rbt-breadcrumb-item active">
                Problem Solving Help
              </li>
            </ul>
          </div>
        </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} isService={false} btnText={"Assignment Help"} />
      <AskSection/>
       <SiteReviews/>
       <WhatsAppCMP/>
       <InfoSection/>
        <ReferralProgram />
            <Milestonerewards categoryId={categoryId} />
            <BenefitsSection
        subCategoryId={categoryId2}
        setIsModelOpen={setIsModelOpen}
      />

 <GatewaySolution/>
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps: 4,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default AssignmentHelp;
